import { createReducer, on } from '@ngrx/store';
import { quizzesActions } from '../actions/quizzes.actions';
import { Quiz } from '../models';
import { PaginationParams } from '../types';

export interface QuizzesState {
    loaded: boolean | null;
    loading: boolean | null;
    quizzes: Quiz[];
    total: number;
    page: number;
    limit: number;
    lastParams: PaginationParams;
}

export const initialState: QuizzesState = {
    loaded: null,
    loading: null,
    quizzes: [],
    total: 0,
    page: 1,
    limit: 20,
    lastParams: { page: 1, limit: 20 },
};

export const quizzesReducer = createReducer(
    initialState,
    on(quizzesActions.getQuizzes, (state, { value }): QuizzesState => ({
        ...state,
        loading: true,
        page: value.page,
        limit: value.limit,
        lastParams: value,
    })),
    on(quizzesActions.getQuizzesSuccess, (state, { payload, total }): QuizzesState => ({
        ...state,
        loaded: true,
        loading: false,
        quizzes: payload,
        total,
    })),
    on(quizzesActions.getQuizzesError, (state): QuizzesState => ({
        ...state,
        loaded: false,
        loading: false,
    })),
    on(quizzesActions.clear, (): QuizzesState => ({ ...initialState })),
);
